import React, { Component } from 'react';
import * as util from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import * as columns from './EmployeeColumns';
import NewEmployee from './NewEmployee';

class Employee extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "EMPLOYEE";
            item.paymentMethodLabel = util.getLabel(util.paymentMethods, item.employee.paymentMethod);
            item.state = util.getSecondValue(util.activeStates, item.employee.active);
            item.stateLabel = util.getLabel(util.activeStates, item.employee.active);
            item.details = this.getDetails(item);
            item.typeLabel = util.getLabel(util.employeeTypes, item.employee.type);
            item.driverLicenseLabel = util.getLabel(util.driverLicenses, item.employee.haveDriverLicense);
            return item;
        })
        return data;
    }

    getDetails(item) {
        let details = [];
        details.push({ "label": "Típus", "value": util.getLabel(util.employeeTypes, item.employee.type) });
        details.push({ "label": "Név", "value": item.employee.name });
        details.push({ "label": "Anyja neve", "value": item.employee.mothersName });
        details.push({ "label": "Születési hely", "value": item.employee.birthPlace });
        details.push({ "label": "Születési idő", "value": item.employee.birthDate });
        details.push({ "label": "TAJ szám", "value": item.employee.insuranceNumber });
        details.push({ "label": "Adószám", "value": item.employee.taxNumber });
        details.push({ "label": "Státusz", "value": util.getLabel(util.activeStates, item.employee.active) });
        if ("FULL_TIME" === item.employee.type) {
            details.push({ "label": "Bruttó fizetés", "value": item.employee.currentGrossSalary });
            details.push({ "label": "Nettó fizetés", "value": item.employee.currentNetSalary });
            details.push({ "label": "Fizetési mód", "value": util.getLabel(util.paymentMethods, item.employee.paymentMethod) });
        }
        details.push({ "label": "Cím", "value": item.employee.address });
        details.push({ "label": "Legmagasabb iskolai végzettség", "value": this.getHighestSchool(item.employee.highestSchool) });
        details.push({ "label": "Szakképzettség", "value": item.employee.qualification });
        if ("FULL_TIME" === item.employee.type) {
            details.push({ "label": "Jogviszony kezdete", "value": item.startDate });
            details.push({ "label": "Jogviszony vége", "value": item.endDate });
            details.push({ "label": "Határozott idő lejárta", "value": item.employee.definiteContractEnd ? new Date(item.employee.definiteContractEnd) : null });
            details.push({ "label": "Napi munkaidő (óra)", "value": item.employee.workingHours });
            details.push({ "label": "Szabadság napok az évre", "value": item.employee.currentVacationDays });
            details.push({ "label": "Igényt tart-e gyerekek után járó pótszabadságra?", "value": this.getTrueFalseValue(item.employee.wantsVacationAfterKids) });
            details.push({ "label": "Igényt tart-e családi kedvezményre?", "value": this.getTrueFalseValue(item.employee.wantsFamilyDiscount) });
            details.push({ "label": "Igényt tart-e első házasok kedvezményére?", "value": this.getTrueFalseValue(item.employee.wantsMarriageDiscount) });
            details.push({ "label": "Jogosult-e fogyatékos kedvezményre?", "value": this.getTrueFalseValue(item.employee.eligibleForDisabilityDiscount) });
            details.push({ "label": "Adott-e le előző munkaviszony leszámoló papírjait?", "value": this.getTrueFalseValue(item.employee.haveExitPapersFromPreviousEmployment) });
            details.push({ "label": "Adott-e le tb kiskönyvet?", "value": this.getTrueFalseValue(item.employee.haveTbBook) });
        }
        details.push({ "label": "Van-e jogosítványa?", "value": this.getTrueFalseHavingValue(item.employee.haveDriverLicense) });
        return details;
    }

    getTrueFalseValue(value) {
        if (value === null) {
            value = "null";
        }
        let result = util.trueFalse.find(p => p.value === value.toString());
        return result.label;
    }

    getTrueFalseHavingValue(value) {
        if (value === null) {
            value = "null";
        }
        let result = util.trueFalseHaving.find(p => p.value === value.toString());
        return result.label;
    }

    getHighestSchool(value) {
        if (!value) {
            value = "NONE";
        }
        return util.highestSchool.find(p => p.value === value).label;
    }

    render() {
        return (
            <>
                {/* <LinkTab tabs={tabs} index={0} /> */}
                <MainTable
                    divClassName="employee"
                    tableName="Munkavállalók"
                    newObjectLabel="Új munkavállaló hozzáadása"
                    path='/api/employees'
                    enrich={this.enrich}
                    columns={(refresh) => columns.columns(refresh)}
                    dialogContent={(refresh, close) => <NewEmployee refresh={refresh} close={close} />}
                    dialogSize={"lg"} />
            </>
        );
    }
}

export default Employee;